import { WorkflowType } from '@/client/services/api/graphql/gql/graphql';
import { useTranslation } from 'react-i18next';

export const useAdminAssignments = () => {
  const { t } = useTranslation();

  const automationTypeTranslationMap: {
    [key in Exclude<WorkflowType, WorkflowType.PointInTime>]: string;
  } = {
    [WorkflowType.AttendedWorkshop]: t('admin.assignments.automations.attendedWorkshop'),
    [WorkflowType.CompletedAssignment]: t('admin.assignments.automations.completedAssignment'),
    [WorkflowType.CompletedContent]: 'When a user completes content',
    [WorkflowType.Hired_60]: t('admin.assignments.automations.hiredGeneral'),
    [WorkflowType.Hired_90]: t('admin.assignments.automations.hiredGeneral'),
    [WorkflowType.HiredCustom]: t('admin.assignments.automations.hiredGeneral'),
    [WorkflowType.HiredToday]: t('admin.assignments.automations.hiredToday'),
    [WorkflowType.RegisteredWorkshop]: t('admin.assignments.automations.registeredWorkshop'),
    [WorkflowType.UserAdded]: t('admin.assignments.automation.userAdded'),
    [WorkflowType.UserUpdated]: t('admin.assignments.automation.userUpdated'),
    [WorkflowType.UserAddedOrUpdated]: t('admin.assignments.automation.userAddedOrUpdated'),
  };

  return {
    automationTypeTranslationMap,
  };
};
